import React from 'react';
import {useSelector} from 'react-redux';
import BaseLayout from '../../../layout/BaseLayout';
import PresenterView from './parts/PresenterView';
import ViewerView from './parts/ViewerView';
import {roomSelector} from '../../../../store/selectors/roomRunFile.selectors';

function LobbyPage(): JSX.Element {
    const room = useSelector(roomSelector);

    return (
        <BaseLayout hasPresActions={false} inLobby>
            <>{room.roomId && <div>{room.isPresenter ? <PresenterView /> : <ViewerView />}</div>}</>
        </BaseLayout>
    );
}

export default LobbyPage;
